import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BackgroundVideo = () => {
    const [backgroundVideos, setBackgroundVideos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({
        source: "",
        id: null,
    });

    useEffect(() => {
        fetchBackgroundVideos();
    }, []);

    const fetchBackgroundVideos = () => {
        axios
            .get("https://api.glyphqai.com/api/get-backgroundvideo")
            .then((response) => {
                if (response.data.status === 200) {
                    setBackgroundVideos(response.data.backgroundvideo);
                }
            })
            .catch((error) => console.error("Error fetching background videos:", error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = (type, video = null) => {
        setModalType(type);
        if (type === "edit" && video) {
            setFormData({
                source: "",
                id: video.id,
            });
        } else {
            setFormData({ source: "", id: null });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formPayload = new FormData();
        formPayload.append("source", formData.source);

        if (modalType === "add") {
            axios
                .post("https://api.glyphqai.com/api/store-backgroundvideo", formPayload, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then(() => {
                    toast.success("Background video added successfully!");
                    fetchBackgroundVideos();
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error storing background video:", error);
                    toast.error("Failed to add background video.");
                });
        } else if (modalType === "edit") {
            axios
                .put(
                    `https://api.glyphqai.com/api/update-backgroundvideo/${formData.id}`,
                    formPayload,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                )
                .then(() => {
                    toast.success("Background video updated successfully!");
                    fetchBackgroundVideos();
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error updating background video:", error);
                    toast.error("Failed to update background video.");
                });
        }
    };

    const handleDelete = (id) => {
        axios
            .delete(`https://api.glyphqai.com/api/deletebackgroundvideo/${id}`)
            .then(() => {
                setBackgroundVideos(backgroundVideos.filter((item) => item.id !== id));
                toast.success("Background video deleted successfully!");
            })
            .catch((error) => {
                console.error("Error deleting background video:", error);
                toast.error("Failed to delete background video.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3 mt-5">
                    <h2 className="display-5 font-bold">Background Videos</h2>
                    <Button onClick={() => handleOpenModal("add")} className="mb-3">
                        Add Background Video
                    </Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th>Video</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {backgroundVideos.map((item, index) => (
                            <tr key={item.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                    <video
                                        width="200"
                                        controls
                                        src={`https://api.glyphqai.com/uploads/backgroundvideo/${item.source}`}
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                </td>
                                <td>
                                    {/* <Button onClick={() => handleOpenModal("edit", item)}>Edit</Button>{" "} */}
                                    <Button variant="danger" onClick={() => handleDelete(item.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal for Add/Edit Background Video */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === "add" ? "Add Background Video" : "Edit Background Video"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formSource" className="mt-3">
                            <Form.Label>File</Form.Label>
                            <Form.Control
                                type="file"
                                name="source"
                                onChange={(e) => setFormData({ ...formData, source: e.target.files[0] })}
                                required
                            />
                        </Form.Group>
                        <Button className="mt-3" type="submit">
                            {modalType === "add" ? "Add Video" : "Update Video"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default BackgroundVideo;
